module.exports = __webpack_public_path__ + "img/02_no.978dbc0f.svg";